export default __webpack_public_path__ + "static/media/15.31799f09.png";